export const service1 = require('./service1.jpg');
export const service2 = require('./service2.jpg');
export const service3 = require('./service3.jpg');
export const serviceHero = require('./serviceHero.mp4');